import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import { blogPosts } from "./blogData";
import "./blog.css";
import Navbar from "../NavBar/NavBar.js";
import Spinner from "../Home/Spinner.js";
import Footer from "../Home/Footer.js";
import Whatsapp from "../Home/Whatsapp.js";

export default function BlogPage() {
  useEffect(() => {
  document.title =
    "Blog UNIK SYSTEM | Actualités & Conseils en Architecture Textile et Design";

  let metaDescription = document.querySelector("meta[name='description']");
  if (!metaDescription) {
    metaDescription = document.createElement("meta");
    metaDescription.name = "description";
    document.head.appendChild(metaDescription);
  }
  metaDescription.setAttribute(
    "content",
    "Blog UNIK SYSTEM : conseils, tendances et actualités en plafonds tendus, architecture textile, éclairage LED et design intérieur au Maroc."
  );

  let metaKeywords = document.querySelector("meta[name='keywords']");
  if (!metaKeywords) {
    metaKeywords = document.createElement("meta");
    metaKeywords.name = "keywords";
    document.head.appendChild(metaKeywords);
  }
  metaKeywords.setAttribute(
    "content",
    "blog architecture textile maroc, plafond tendu conseils, design intérieur maroc, UNIK SYSTEM blog"
  );
}, []);


  const POSTS_PER_PAGE = 8; // 🔧 nombre d’articles par page
  const [currentPage, setCurrentPage] = useState(1);

  const totalPages = Math.ceil(blogPosts.length / POSTS_PER_PAGE);
  const startIndex = (currentPage - 1) * POSTS_PER_PAGE;
  const currentPosts = blogPosts.slice(
    startIndex,
    startIndex + POSTS_PER_PAGE
  );

  return (
    <>
      <Spinner />
      <Navbar />
      <Whatsapp />

      <div className="blog-page">

        <section className="blog-hero">
          <h1 className="section-titles">Blog UNIK SYSTEM</h1>
          <p style={{ color: "#807773" }}>
            Actualités, conseils & expertise architecture textile
          </p>
        </section>

        {/* ARTICLES */}
        <div className="blog-grid">
          {currentPosts.map(post => (
            <div key={post.id} className="blog-card">
              <img src={post.cover} alt={post.title} />

              <div className="blog-card-body">
                <h5 className="section-titles">{post.title}</h5>
                <p>{post.excerpt}</p>
                <span style={{ color: "#807773" }}>{post.date}</span>
                <br /><br />

                <Link to={`/blog/${post.id}`} id="btn-botton">
                  <button className="btn-primarya">
                    Lire l’article
                  </button>
                </Link>
              </div>
            </div>
          ))}
        </div>

        {/* PAGINATION */}
        {totalPages > 1 && (
          <div className="pagination">
            <button
              className="page-btn"
              disabled={currentPage === 1}
              onClick={() => setCurrentPage(currentPage - 1)}
            >
              ← Précédent
            </button>

            {[...Array(totalPages)].map((_, i) => (
              <button
                key={i}
                className={`page-btn ${currentPage === i + 1 ? "active" : ""}`}
                onClick={() => setCurrentPage(i + 1)}
              >
                {i + 1}
              </button>
            ))}

            <button
              className="page-btn"
              disabled={currentPage === totalPages}
              onClick={() => setCurrentPage(currentPage + 1)}
            >
              Suivant →
            </button>
          </div>
        )}

      </div>

      <Footer />
    </>
  );
}
